import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
import { VISUAL_IMAGE, VISUAL_IMAGE_ALT } from '../data/offer';
const imagine = ['Imagine explaining Ohm’s law with one clear, labeled visual.', 'Walking students through a three-way switch circuit wire by wire.', 'Showing a reversed-polarity receptacle and a correctly wired one side by side.', 'Tracing a ladder diagram and knowing exactly why the motor starts or stops.', 'And connecting every task to a safe, tested and code-aware installation.'];
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-332" data-mp="3gb8q5752jhqh">
      <div className="max-w-5xl mx-auto" data-id="element-333" data-mp="3l8ioxdecl5qz">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-334" data-mp="3l9aarwi57p42">
          <div data-id="element-335" data-mp="eq0qidc5xi00">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-[#0B1F4D] uppercase" data-id="element-336" data-mp="etomdj52yghw">
              See What You&apos;re Teaching
            </h2>
            <p className="text-xl font-semibold text-[#0B1F4D] mb-1" data-id="element-337" data-mp="nr8mgor7i6qx">Electricity Is Hard to Explain With Words.</p>
            <p className="text-xl font-semibold text-[#1236C0] mb-5" data-id="element-338" data-mp="jr6keehk7bb4">
              Your Teaching Materials Shouldn&apos;t Be.
            </p>
            <div className="space-y-3 text-slate-700 leading-relaxed" data-id="element-339" data-mp="3n7dmigkbt0hs">
              <p data-id="element-340" data-mp="3n5apvdoo4943">{imagine.join(' ')}</p>
              <p className="font-semibold text-[#0B1F4D]" data-id="element-341" data-mp="4txrvhgis1ht">
                That&apos;s the advantage of a 100% visual training system.
              </p>
              <p data-id="element-342" data-mp="1eeollqv8dj">
                <span className="font-semibold text-[#7A5C00]" data-id="element-343" data-mp="uu0x4pm5vt">ELECTRICAL TECHNOLOGY INSTRUCTOR ATLAS</span> is
                built around illustrations, labeled diagrams, wiring sequences, numbered breakdowns, ❌/✅
                comparisons, teaching cues, drills and quick checks.
              </p>
            </div>
          </div>

          <div className="bg-[#F3F6FC] border border-[#D2DCEC] rounded-2xl p-6" data-id="element-344" data-mp="1ceky2bw2i7pu">
            <p className="text-sm font-bold text-[#7A5C00] uppercase tracking-wider mb-4" data-id="element-345" data-mp="1h6crcu6lyrjo">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-346" data-mp="1m3us3xah20gl">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-347" data-mp="oj8g47gx9gzg">
                  <CheckCircle2 size={16} className="text-[#1236C0] shrink-0 mt-0.5" data-id="element-348" data-mp="th0ijvf70lhw" />
                  <span data-id="element-349" data-mp="yesa2obxe5lk">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} src={VISUAL_IMAGE} alt={VISUAL_IMAGE_ALT} loading="lazy" className="w-full max-w-2xl h-auto mx-auto mt-12 rounded-2xl border border-[#D2DCEC] shadow-lg shadow-[#0B1F4D]/10" data-id="element-350" data-mp="13fzjssxmpeuv" />

        <p className="text-center text-2xl md:text-4xl font-extrabold tracking-tight text-[#0B1F4D] mt-14" data-id="element-351" data-mp="3plsx60yaxih4">
          <span className="text-[#1236C0]" data-id="element-352" data-mp="3knhnbq80b7yw">100% VISUAL.</span> PRACTICAL. PROFESSIONAL.{' '}
          <span className="bg-[#0B1F4D] text-white px-2 box-decoration-clone" data-id="element-353" data-mp="3fnmz5ufm8whj">BUILT TO TEACH.</span>
        </p>
      </div>
    </section>;
}